import React from "react";
import { MarkerType } from "react-flow-renderer";

// const level1 = "#8dccad";
// const level2 = "#f5cc7f";
// const level3 = "#7b9fe0";
// const level4 = "#f27c8d";
// const level5 = "#fdb367";
// const level6 = "#de723a";
// const black = "black";

const level1 = "rgb(17, 3, 3, 0.1)";
const level2 = "rgb(0, 25, 59, 0.9)";
const level3 = "rgb(0, 25, 59, 0.9)";
const level4 = "#003379";
const level5 = "#0a0f17";
const level6 = "#de723a";
const black = "yellow";

export const nodes = [
  {
    id: "1",
    type: "input",
    data: {
      label: (
        <>
          <strong>CSS Grid!</strong>
          <p>
            Using display: grid; allows you to start your CSS Grid journey!
            <br />
            <br />
            Utilize the minimap in the bottom right as a guide. <br />
            <br />I recommend going from left to right
          </p>
        </>
      ),
    },
    position: { x: -352, y: 10 },
    style: {
      background: level1,
      color: black,
      border: "1px solid #222138",
      width: 1000,
    },
  },

  // {
  //   id: "3",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Before</strong>
  //         <p>
  //           {` .css-grid-item{margin-bottom: 0.5em;`}
  //           <br />
  //           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  //           {`padding: 0.5em;}`}
  //           <br />
  //         </p>
  //         <p className="css-grid-item">css-grid-item 1 </p>
  //         <p className="css-grid-item">css-grid-item 2</p>
  //         <p className="css-grid-item">css-grid-item 3</p>
  //       </>
  //     ),
  //   },
  //   position: { x: -500, y: 60 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 600,
  //   },
  // },

  // {
  //   id: "2",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Basics</strong>
  //       </>
  //     ),
  //   },
  //   position: { x: -600, y: 230 },
  //   style: {
  //     background: level3,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 1500,
  //   },
  // },

  {
    id: "3",

    data: {
      label: (
        <>
          <strong>Creating Column(s) and/or Row(s)</strong>
          <p>
            Use grid-template-rows and grid-template-columns to design your
            grid.
          </p>
          <iframe
            height="2000"
            width="100%"
            scrolling="no"
            title="columns and rows"
            src="https://codepen.io/jonathanelias1/embed/preview/mdLxRzL?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/mdLxRzL">
              columns and rows
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -2940, y: 600 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 800,
    },
  },

  // {
  //   id: "4",

  //   data: {
  //     label: (
  //       <>
  //         <strong>1 column</strong>
  //         <p>
  //           {`div{display: grid;`}
  //           <br />
  //           {`grid-template-columns: 100px;}`}
  //         </p>
  //         <div className="grid-template-columns">
  //           <p className="css-grid-item">css-grid-item 1</p>
  //           <p className="css-grid-item">css-grid-item 2</p>
  //           <p className="css-grid-item">css-grid-item 3</p>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -500, y: 400 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 500,
  //   },
  // },

  // {
  //   id: "5",

  //   data: {
  //     label: (
  //       <>
  //         <strong>More than 1 column</strong>
  //         <p>
  //           display: grid;
  //           <br />
  //           grid-template-columns: 100px 200px 50px;
  //         </p>
  //         <div className="grid-template-columns-2">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item">css-grid-item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -700, y: 800 },
  //   style: {
  //     background: level5,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 360,
  //   },
  // },

  // {
  //   id: "6",

  //   data: {
  //     label: (
  //       <>
  //         <strong>1 Row</strong>
  //         <p>
  //           display: grid;
  //           <br />
  //           grid-template-rows: 100px;
  //         </p>
  //         <div className="grid-template-rows">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item">css-grid-item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -100, y: 400 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 680,
  //   },
  // },

  // {
  //   id: "7",

  //   data: {
  //     label: (
  //       <>
  //         <strong>More than 1 row</strong>
  //         <p>
  //           display: grid;
  //           <br />
  //           grid-template-rows: 100px 200px 300px;
  //         </p>
  //         <div className="grid-template-rows-2">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item">css-grid-item 3</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -200, y: 800 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 320,
  //   },
  // },
  // {
  //   id: "8",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Rows and columns</strong>
  //         <p className="paragraph-text">
  //           Grid-template-columns affects the width of the items from left to
  //           right so item 1 is 100px wide, item 2 is 150px wide, and item 3 is
  //           200px wide. Meanwhile, our rows make item 1 through item 3 have a
  //           height of 50px but then in our second row (items 4-6) our height is
  //           100px. Then it goes back to a height of 50px for item 7 because it
  //           will default to our first value since we didn't state a height for
  //           our third row. Our width for item 7 is also 100px because it's in
  //           the first column.
  //         </p>
  //         <p>
  //           display: grid;
  //           <br />
  //           grid-template-columns: 100px 150px 200px;
  //           <br />
  //           grid-template-rows: 50px 100px;
  //         </p>
  //         <div className="grid-template-columns-and-rows">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item">css-grid-item 3</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //           <div className="css-grid-item">css-grid-item 7</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: -650, y: 1600 },
  //   style: {
  //     background: level6,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 460,
  //   },
  // },

  // {
  //   id: "9",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Before</strong>
  //         <p>
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid Item 1: <br />
  //           grid-column-start: 1; <br />
  //           grid-column-end: 3;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="css-grid-item">50 x 100 (Top Left)</div>
  //           <div className="css-grid-item">100 x 100 (Top Middle)</div>
  //           <div className="css-grid-item">150 x 100 (Top Right)</div>
  //           <div className="css-grid-item">50 x 150 (Middle Left)</div>
  //           <div className="css-grid-item">100 x 150 (Middle)</div>
  //           <div className="css-grid-item">150 x 150 (Middle Right)</div>
  //           <div className="css-grid-item">50 x 200 (Bottom Left)</div>
  //           <div className="css-grid-item">100 x 200 (Bottom Middle)</div>
  //           <div className="css-grid-item">150 x 200 (Bottom Right)</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 500, y: 50 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },

  {
    id: "9",

    data: {
      label: (
        <>
          <strong>Grid Start & End</strong>
          <p>
            Utilize the grid start and end properties to access individual CSS
            Grid items.
          </p>
          <iframe
            height="2000"
            width="100%"
            scrolling="no"
            title="columns and rows"
            src="https://codepen.io/jonathanelias1/embed/preview/PoeRpdY?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/PoeRpdY">
              columns and rows
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -2070, y: 600 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 1000,
    },
  },

  // {
  //   id: "11",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Access Top Left item</strong>
  //         <p>
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid Item 1: <br />
  //           grid-row-start: 1; <br />
  //           grid-row-end: 2; <br />
  //           grid-column-start: 1; <br />
  //           grid-column-end: 2; <br />
  //           background-color: yellow;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="grid-container-1"> TARGET 50 x 100 (Top Left)</div>

  //           <div className="css-grid-item">100 x 100 (Top Middle)</div>
  //           <div className="css-grid-item">150 x 100 (Top Right)</div>
  //           <div className="css-grid-item">50 x 150 (Middle Left)</div>
  //           <div className="css-grid-item">100 x 150 (Middle)</div>
  //           <div className="css-grid-item">150 x 150 (Middle Right)</div>
  //           <div className="css-grid-item">50 x 200 (Bottom Left)</div>
  //           <div className="css-grid-item">100 x 200 (Bottom Middle)</div>
  //           <div className="css-grid-item">150 x 200 (Bottom Right)</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 400, y: 1300 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },
  // {
  //   id: "12",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Access Top Middle item</strong>
  //         <p>
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid Item 1: <br />
  //           grid-row-start: 1; <br />
  //           grid-row-end: 2; <br />
  //           grid-column-start: 2; <br />
  //           grid-column-end: 3; <br />
  //           background-color: yellow;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="grid-container-2">TARGET 100 x 100(Top Middle)</div>

  //           <div className="css-grid-item">50 x 100 (Top Left)</div>
  //           <div className="css-grid-item">150 x 100 (Top Right)</div>
  //           <div className="css-grid-item">50 x 150 (Middle Left)</div>
  //           <div className="css-grid-item">100 x 150 (Middle)</div>
  //           <div className="css-grid-item">150 x 150 (Middle Right)</div>
  //           <div className="css-grid-item">50 x 200 (Bottom Left)</div>
  //           <div className="css-grid-item">100 x 200 (Bottom Middle)</div>
  //           <div className="css-grid-item">150 x 200 (Bottom Right)</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 900, y: 1300 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },

  // {
  //   id: "13",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Access Top Right item</strong>
  //         <p>
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid Item 1: <br />
  //           grid-row-start: 1; <br />
  //           grid-row-end: 2; <br />
  //           grid-column-start: 3; <br />
  //           grid-column-end: 4; <br />
  //           background-color: yellow;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="css-grid-item">50 x 100 (Top Left)</div>
  //           <div className="css-grid-item">100 x 100 (Top Middle)</div>

  //           <div className="grid-container-3">TARGET 150 x 100 (Top Right)</div>
  //           <div className="css-grid-item">50 x 150 (Middle Left)</div>
  //           <div className="css-grid-item">100 x 150 (Middle)</div>
  //           <div className="css-grid-item">150 x 150 (Middle Right)</div>
  //           <div className="css-grid-item">50 x 200 (Bottom Left)</div>
  //           <div className="css-grid-item">100 x 200 (Bottom Middle)</div>
  //           <div className="css-grid-item">150 x 200 (Bottom Right)</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 1400, y: 1300 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },

  {
    id: "14",

    data: {
      label: (
        <>
          <strong> Access individual CSS Grid items Video Guide</strong>
          <p>
            This video explains how to use grid start and end for visual
            learners.
          </p>
          <div className="video-responsive">
            <iframe
              src={`https://www.youtube.com/embed/SlVCv8Ntjvs`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded youtube"
            />
          </div>
        </>
      ),
    },
    position: { x: -1000, y: 600 },
    style: {
      background: level4,
      color: black,
      border: "25px solid #003379",
      width: 1000,
    },
  },

  // {
  //   id: "15",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Access Middle Left item</strong>
  //         <p>
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid Item 1: <br />
  //           grid-row-start: 2; <br />
  //           grid-row-end: 3; <br />
  //           grid-column-start: 1; <br />
  //           grid-column-end: 2; <br />
  //           background-color: yellow;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="css-grid-item">50 x 100 (Top Left)</div>
  //           <div className="css-grid-item">100 x 100 (Top Middle)</div>

  //           <div className="css-grid-item">150 x 100 (Top Right)</div>
  //           <div className="grid-container-4">
  //             {" "}
  //             TARGET 50 x 150 (Middle Left)
  //           </div>
  //           <div className="css-grid-item">100 x 150 (Middle)</div>
  //           <div className="css-grid-item">150 x 150 (Middle Right)</div>
  //           <div className="css-grid-item">50 x 200 (Bottom Left)</div>
  //           <div className="css-grid-item">100 x 200 (Bottom Middle)</div>
  //           <div className="css-grid-item">150 x 200 (Bottom Right)</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 400, y: 2000 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },

  // {
  //   id: "16",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Access Middle item</strong>
  //         <p className="">
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid Item 1: <br />
  //           grid-row-start: 2; <br />
  //           grid-row-end: 3; <br />
  //           grid-column-start: 2; <br />
  //           grid-column-end: 3; <br />
  //           background-color: yellow;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="css-grid-item">50 x 100 (Top Left)</div>
  //           <div className="css-grid-item">100 x 100 (Top Middle)</div>

  //           <div className="css-grid-item">150 x 100 (Top Right)</div>
  //           <div className="css-grid-item"> 50 x 150 (Middle Left)</div>
  //           <div className="grid-container-5">TARGET 100 x 150 (Middle)</div>
  //           <div className="css-grid-item">150 x 150 (Middle Right)</div>
  //           <div className="css-grid-item">50 x 200 (Bottom Left)</div>
  //           <div className="css-grid-item">100 x 200 (Bottom Middle)</div>
  //           <div className="css-grid-item">150 x 200 (Bottom Right)</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 900, y: 2000 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },

  // {
  //   id: "17",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Middle right item</strong>
  //         <p className="">
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid Item 1: <br />
  //           grid-row-start: 2; <br />
  //           grid-row-end: 3; <br />
  //           grid-column-start: 3; <br />
  //           grid-column-end: 4; <br />
  //           background-color: yellow;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="css-grid-item">50 x 100 (Top Left)</div>
  //           <div className="css-grid-item">100 x 100 (Top Middle)</div>

  //           <div className="css-grid-item">150 x 100 (Top Right)</div>
  //           <div className="css-grid-item"> 50 x 150 (Middle Left)</div>
  //           <div className="css-grid-item"> 100 x 150 (Middle)</div>
  //           <div className="grid-container-6">
  //             {" "}
  //             TARGET 150 x 150 (Middle Right)
  //           </div>
  //           <div className="css-grid-item">50 x 200 (Bottom Left)</div>
  //           <div className="css-grid-item">100 x 200 (Bottom Middle)</div>
  //           <div className="css-grid-item">150 x 200 (Bottom Right)</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 1400, y: 2000 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },

  // {
  //   id: "18",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Access Bottom Left item</strong>
  //         <p className="">
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid Item 1: <br />
  //           grid-row-start: 3; <br />
  //           grid-row-end: 4; <br />
  //           grid-column-start: 1; <br />
  //           grid-column-end: 2; <br />
  //           background-color: yellow;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="css-grid-item">50 x 100 (Top Left)</div>
  //           <div className="css-grid-item">100 x 100 (Top Middle)</div>

  //           <div className="css-grid-item">150 x 100 (Top Right)</div>
  //           <div className="css-grid-item"> 50 x 150 (Middle Left)</div>
  //           <div className="css-grid-item"> 100 x 150 (Middle)</div>
  //           <div className="css-grid-item"> 150 x 150 (Middle Right)</div>
  //           <div className="grid-container-7">
  //             TARGET 50 x 200 (Bottom Left)
  //           </div>
  //           <div className="css-grid-item">100 x 200 (Bottom Middle)</div>
  //           <div className="css-grid-item">150 x 200 (Bottom Right)</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 400, y: 2700 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },

  // {
  //   id: "19",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Access Bottom Middle item</strong>
  //         <p className="">
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid Item 1: <br />
  //           grid-row-start: 3; <br />
  //           grid-row-end: 4; <br />
  //           grid-column-start: 2; <br />
  //           grid-column-end: 3; <br />
  //           background-color: yellow;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="css-grid-item">50 x 100 (Top Left)</div>
  //           <div className="css-grid-item">100 x 100 (Top Middle)</div>

  //           <div className="css-grid-item">150 x 100 (Top Right)</div>
  //           <div className="css-grid-item"> 50 x 150 (Middle Left)</div>
  //           <div className="css-grid-item"> 100 x 150 (Middle)</div>
  //           <div className="css-grid-item"> 150 x 150 (Middle Right)</div>
  //           <div className="css-grid-item">50 x 200 (Bottom Left)</div>
  //           <div className="grid-container-8">
  //             {" "}
  //             TARGET 100 x 200 (Bottom Middle)
  //           </div>
  //           <div className="css-grid-item">150 x 200 (Bottom Right)</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 900, y: 2700 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },

  // {
  //   id: "20",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Bottom Right item</strong>
  //         <p className="">
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid Item 1: <br />
  //           grid-row-start: 3; <br />
  //           grid-row-end: 4; <br />
  //           grid-column-start: 3; <br />
  //           grid-column-end: 4; <br />
  //           background-color: yellow;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="css-grid-item">50 x 100 (Top Left)</div>
  //           <div className="css-grid-item">100 x 100 (Top Middle)</div>

  //           <div className="css-grid-item">150 x 100 (Top Right)</div>
  //           <div className="css-grid-item"> 50 x 150 (Middle Left)</div>
  //           <div className="css-grid-item"> 100 x 150 (Middle)</div>
  //           <div className="css-grid-item"> 150 x 150 (Middle Right)</div>
  //           <div className="css-grid-item">50 x 200 (Bottom Left)</div>
  //           <div className="css-grid-item">100 x 200 (Bottom Middle)</div>
  //           <div className="grid-container-9">
  //             TARGET 150 x 200 (Bottom Right)
  //           </div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 1400, y: 2700 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },

  // {
  //   id: "21",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Fill up Entire Middle Column of items</strong>
  //         <p className="">
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid container 1: <br />
  //           grid-column-start: 2; <br />
  //           grid-column-end: 3;
  //           <br />
  //           grid-row-start: 1;
  //           <br />
  //           grid-row-end: 5; <br />
  //           background-color: yellow;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="grid-container-10"></div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 400, y: 3400 },
  //   style: {
  //     background: level5,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },

  // {
  //   id: "22",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Fill up Entire Middle Row of items</strong>
  //         <p className="">
  //           Grid <br />
  //           display: grid;
  //           <br />
  //           grid-template-rows: 50px 100px 150px;
  //           <br />
  //           grid-template-columns: 100px 150px 200px; <br />
  //           Grid container 1: <br />
  //           grid-column-start: 1; <br />
  //           grid-column-end: 4; <br />
  //           grid-row-start: 2; <br />
  //           grid-row-end: 3; <br />
  //           background-color: yellow;
  //         </p>
  //         <div className="grid-template-start">
  //           <div className="grid-container-11"></div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 900, y: 3400 },
  //   style: {
  //     background: level5,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 470,
  //   },
  // },

  // {
  //   id: "23",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Before</strong>
  //         <p className="">
  //           display: grid: <br />
  //           grid-template-rows: 100px 100px 100px; <br />
  //           grid-template-columns: 200px 200px 200px; <br />
  //         </p>
  //         <div className="css-span-before-grid">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 2000, y: 60 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 420,
  //   },
  // },

  {
    id: "24",

    data: {
      label: (
        <>
          <strong>Span</strong>
          <p>Use span to make a CSS Grid item taller or wider</p>
          <iframe
            height="1240"
            width="100%"
            scrolling="no"
            title="span"
            src="https://codepen.io/jonathanelias1/embed/preview/NWMYgdL?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen="true"
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/NWMYgdL">span</a> by
            Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 266, y: 600 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 800,
    },
  },

  // {
  //   id: "25",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Make an item taller by doing span on grid-row</strong>
  //         <p className="">
  //           Grid: display: grid; <br />
  //           grid-template-rows: 100px 100px 100px; <br />
  //           grid-template-columns: 200px 200px 200px; <br />
  //           Grid Item 1: <br />
  //           background: #B823C1; <br />
  //           grid-row: span 2; <br />
  //           margin: 0.5em; <br />
  //           padding: 0.5em;
  //         </p>
  //         <div className="css-grid-span">
  //           <div className="css-grid-item-span-row-1">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 2000, y: 500 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 420,
  //   },
  // },

  // {
  //   id: "26",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Make an item wider by doing span on grid-column</strong>
  //         <p className="">
  //           Grid: display: grid; <br />
  //           grid-template-rows: 100px 100px 100px; <br />
  //           grid-template-columns: 200px 200px 200px; <br />
  //           Grid Item 1: <br />
  //           background: #B823C1; <br />
  //           grid-column: span 2; <br />
  //           margin: 0.5em; <br />
  //           padding: 0.5em;
  //         </p>
  //         <div className="css-grid-span">
  //           <div className="css-grid-item-span-column-1">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 2500, y: 500 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 620,
  //   },
  // },

  // {
  //   id: "27",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Before</strong>
  //         <p className="">
  //           Grid BEFORE AUTO <br />
  //           display: grid: <br />
  //           grid-template-rows: 50px 50px 50px; <br />
  //           grid-template-columns: 100px 100px 100px; <br />
  //         </p>
  //         <div className="grid-before-auto">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item">
  //             css-grid-item 3 (longer item than the others to show how auto can
  //             be helpful)
  //           </div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 3200, y: 60 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 320,
  //   },
  // },

  {
    id: "28",

    data: {
      label: (
        <>
          <strong>Auto Property</strong>
          <p>
            The auto property lets us deal easily with sizing issues in CSS
            Grid.{" "}
          </p>
          <iframe
            height="1500"
            width="100%"
            scrolling="no"
            title="span"
            src="https://codepen.io/jonathanelias1/embed/preview/NWMYVGR?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen="true"
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/NWMYVGR">
              align self
            </a>
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 1134, y: 600 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 1000,
    },
  },

  // {
  //   id: "29",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Auto</strong>
  //         <p className="">
  //           display: grid: <br />
  //           grid-template-rows: 50px 50px auto; <br />
  //           grid-template-columns: 100px 100px 100px; <br />
  //         </p>
  //         <div className="grid-auto">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item">
  //             css-grid-item 3 (longer item than the others to show how auto can
  //             be helpful)
  //           </div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 3200, y: 660 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 320,
  //   },
  // },

  // {
  //   id: "30",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Before</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //           grid-template-rows: auto; <br />
  //           Grid Item 3 BIG ITEM: <br />
  //           padding: 3em 2em; <br />
  //           margin: 0.5em;
  //         </p>
  //         <div className="grid-before-align">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3 BIG ITEM</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 4180, y: 60 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 535,
  //   },
  // },

  {
    id: "31",

    data: {
      label: (
        <>
          <strong>Align Items</strong>
          <p>
            Use the align-items property to control the alignment of all items
            in a CSS Grid at once.{" "}
          </p>
          <p>
            Syntax:
            align-items:(stretch/center/start/end/baseline/initial/inherit){" "}
          </p>
          <iframe
            height="1000"
            width="100%"
            scrolling="no"
            title="align items"
            src="https://codepen.io/jonathanelias1/embed/preview/bGMvZZO?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/bGMvZZO">
              align items
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1082, y: 3000 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 1000,
    },
  },

  {
    id: "32",

    data: {
      label: (
        <>
          <strong>Align Self</strong>
          <p>
            When you have all of your grid items aligned already with
            align-items but you want one or more of the items to be aligned
            differently you can apply the align-self property to individual grid
            items.
          </p>
          <p>
            Syntax:
            align-self:(stretch/center/start/end/baseline/initial/inherit)
          </p>
          <iframe
            height="1000"
            width="100%"
            scrolling="no"
            title="align items"
            src="https://codepen.io/jonathanelias1/embed/preview/poVLBrg?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/poVLBrg">
              align items
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1086, y: 4500 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 1000,
    },
  },

  // {
  //   id: "32",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Start</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //           grid-template-rows: auto; <br />
  //           align-items: start; <br />
  //           Grid Item 3 BIG ITEM: <br />
  //           padding: 3em 2em; <br />
  //           margin: 0.5em;
  //         </p>
  //         <div className="grid-start-align">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3 BIG ITEM</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 3800, y: 660 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 535,
  //   },
  // },

  // {
  //   id: "33",

  //   data: {
  //     label: (
  //       <>
  //         <strong>End</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //           grid-template-rows: auto; <br />
  //           align-items: end; <br />
  //           Grid Item 3 BIG ITEM: <br />
  //           padding: 3em 2em; <br />
  //           margin: 0.5em;
  //         </p>
  //         <div className="grid-end-align">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3 BIG ITEM</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 4600, y: 660 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 535,
  //   },
  // },

  // {
  //   id: "34",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Center</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //           grid-template-rows: auto; <br />
  //           align-items: center; <br />
  //           Grid Item 3 BIG ITEM: <br />
  //           padding: 3em 2em; <br />
  //           margin: 0.5em;
  //         </p>
  //         <div className="grid-center-align">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3 BIG ITEM</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 3800, y: 1260 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 535,
  //   },
  // },

  // {
  //   id: "35",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Baseline</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //           grid-template-rows: auto; <br />
  //           align-items: baseline; <br />
  //           Grid Item 3 BIG ITEM: <br />
  //           padding: 3em 2em; <br />
  //           margin: 0.5em;
  //         </p>
  //         <div className="grid-baseline-align">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3 BIG ITEM</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 4600, y: 1260 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 535,
  //   },
  // },

  {
    id: "36",

    data: {
      label: (
        <>
          <strong>Justify items</strong>
          <p></p>
          <iframe
            height="1000"
            width="100%"
            scrolling="no"
            title="align items"
            src="https://codepen.io/jonathanelias1/embed/preview/jOxzoyw?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/jOxzoyw">
              align items
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 232, y: 3000 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 1570,
    },
  },

  {
    id: "37",

    data: {
      label: (
        <>
          <strong> Align vs Justify </strong>
          <p>
            The main difference between justifying and aligning items is that in
            most cases, justify affects grid items horizontally while align
            affects grid items vertically. <br /> <br />
            Use these properties together or separately to improve the layout of
            your grid items.
          </p>
          {/* <iframe
            height="1000"
            width="100%"
            scrolling="no"
            title="align items"
            src="https://codepen.io/jonathanelias1/embed/preview/xxjWNWB?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/xxjWNWB">
              justify items
            </a>{" "}
            by Jonathan Elias(
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe> */}
        </>
      ),
    },
    position: { x: -252, y: 2500 },
    style: {
      background: level3,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  // {
  //   id: "37",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Start</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //           grid-template-rows: auto; <br />
  //           justify-items: start; <br />
  //           Grid Item 3 BIG ITEM; <br />
  //           padding: 3em 2em; <br />
  //           margin: 0.5em;
  //         </p>
  //         <div className="grid-justify-start">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3 BIG ITEM</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 5200, y: 660 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 535,
  //   },
  // },

  // {
  //   id: "38",

  //   data: {
  //     label: (
  //       <>
  //         <strong>End</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //           grid-template-rows: auto; <br />
  //           justify-items: end; <br />
  //           Grid Item 3 BIG ITEM; <br />
  //           padding: 3em 2em; <br />
  //           margin: 0.5em;
  //         </p>
  //         <div className="grid-justify-end">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3 BIG ITEM</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 5800, y: 660 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 535,
  //   },
  // },

  // {
  //   id: "39",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Center</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //           grid-template-rows: auto; <br />
  //           justify-items: center; <br />
  //           Grid Item 3 BIG ITEM; <br />
  //           padding: 3em 2em; <br />
  //           margin: 0.5em;
  //         </p>
  //         <div className="grid-justify-center">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3 BIG ITEM</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 5200, y: 1260 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 535,
  //   },
  // },

  // {
  //   id: "40",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Baseline</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //           grid-template-rows: auto; <br />
  //           justify-items: baseline; <br />
  //           Grid Item 3 BIG ITEM; <br />
  //           padding: 3em 2em; <br />
  //           margin: 0.5em;
  //         </p>
  //         <div className="grid-justify-baseline">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3 BIG ITEM</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 5800, y: 1260 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 535,
  //   },
  // },

  // {
  //   id: "41",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Before</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //         </p>
  //         <div className="grid-before-align">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 7120, y: 60 },
  //   style: {
  //     background: level2,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 535,
  //   },
  // },

  {
    id: "39",

    data: {
      label: (
        <>
          <strong>Align Content</strong>
          <p>
            align-content = sets the distribution of space between and around
            content items along a grid's block axis.
          </p>

          <iframe
            height="1500"
            width="100%"
            scrolling="no"
            title="align-content"
            src="https://codepen.io/jonathanelias1/embed/preview/qBYyWxy?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/qBYyWxy">
              align-content
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -984, y: 6050 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 800,
    },
  },

  {
    id: "40",

    data: {
      label: (
        <>
          <strong>Justify Content</strong>
          <p>
            justify-content = defines how the browser distributes space between
            and around content items along the inline axis of a grid container.
          </p>

          <iframe
            height="900"
            width="100%"
            scrolling="no"
            title="justify-content"
            src="https://codepen.io/jonathanelias1/embed/preview/oNdyKrp?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/oNdyKrp">
              justify-content
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 258, y: 6050 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 1570,
    },
  },

  {
    id: "41",

    data: {
      label: (
        <>
          <strong>Justify Self</strong>
          <p>
            Use justify-self to change the horizontal alignment of an individual
            grid item.
          </p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="align self"
            src="https://codepen.io/jonathanelias1/embed/preview/BaxVewa?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/BaxVewa">
              align self
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 230, y: 4500 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 1570,
    },
  },

  {
    id: "42",

    data: {
      label: (
        <>
          <strong>Grid Gap</strong>
          <p>Use the grid gap property to add space between grid items.</p>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="grid gap"
            src="https://codepen.io/jonathanelias1/embed/preview/dyemEro?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/dyemEro">grid gap</a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 2180, y: 600 },
    style: {
      background: level4,
      color: black,
      border: "8px solid #003379",
      width: 1100,
    },
  },

  // {
  //   id: "43",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Put space between columns</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //           grid-column-gap: 50px;
  //         </p>
  //         <div className="grid-before-align-column-gap">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 6680, y: 660 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 625,
  //   },
  // },

  // {
  //   id: "44",

  //   data: {
  //     label: (
  //       <>
  //         <strong>Put space between Rows</strong>
  //         <p className="">
  //           Grid: <br />
  //           display: grid: <br />
  //           grid-template-columns: 150px 150px 200px; <br />
  //           grid-row-gap: 50px;
  //         </p>
  //         <div className="grid-before-align-row-gap">
  //           <div className="css-grid-item">css-grid-item 1</div>
  //           <div className="css-grid-item">css-grid-item 2</div>
  //           <div className="css-grid-item-big"> css-grid-item-3</div>
  //           <div className="css-grid-item">css-grid-item 4</div>
  //           <div className="css-grid-item">css-grid-item 5</div>
  //           <div className="css-grid-item">css-grid-item 6</div>
  //         </div>
  //       </>
  //     ),
  //   },
  //   position: { x: 7480, y: 660 },
  //   style: {
  //     background: level4,
  //     color: black,
  //     border: "1px solid #222138",
  //     width: 535,
  //   },
  // },

  // End of items
];

export const edges = [
  {
    id: "e1-2",
    source: "1",
    target: "2",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-37",
    source: "1",
    target: "37",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-3",
    source: "1",
    target: "3",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-9",
    source: "1",
    target: "9",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e9-14",
    source: "9",
    target: "14",
    animated: true,
    style: { stroke: "#f6ab6c" },
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-24",
    source: "1",
    target: "24",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-28",
    source: "1",
    target: "28",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "1-42",
    source: "1",
    target: "42",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //align vs justify

  {
    id: "e37-31",
    source: "37",
    target: "31",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e37-32",
    source: "37",
    target: "32",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e37-36",
    source: "37",
    target: "36",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e37-39",
    source: "37",
    target: "39",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e37-40",
    source: "37",
    target: "40",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e37-41",
    source: "37",
    target: "41",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //old

  // {
  //   id: "e2-3",
  //   source: "2",
  //   target: "4",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e4-5",
  //   source: "4",
  //   target: "5",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e3-6",
  //   source: "3",
  //   target: "6",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e6-7",
  //   source: "6",
  //   target: "7",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e4-8",
  //   source: "4",
  //   target: "8",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e5-8",
  //   source: "5",
  //   target: "8",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e6-8",
  //   source: "6",
  //   target: "8",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e7-8",
  //   source: "7",
  //   target: "8",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e1-9",
  //   source: "1",
  //   target: "9",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e9-10",
  //   source: "9",
  //   target: "10",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e10-11",
  //   source: "10",
  //   target: "11",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e10-12",
  //   source: "10",
  //   target: "12",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e10-13",
  //   source: "10",
  //   target: "13",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e10-15",
  //   source: "10",
  //   target: "15",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e10-16",
  //   source: "10",
  //   target: "16",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e10-17",
  //   source: "10",
  //   target: "17",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e10-18",
  //   source: "10",
  //   target: "18",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e10-19",
  //   source: "10",
  //   target: "19",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e10-20",
  //   source: "10",
  //   target: "20",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e10-14",
  //   source: "10",
  //   target: "14",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e10-21",
  //   source: "10",
  //   target: "21",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },
  // {
  //   id: "e10-22",
  //   source: "10",
  //   target: "22",
  //   animated: true,
  //   style: { stroke: "#f6ab6c" },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e1-23",
  //   source: "1",
  //   target: "23",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e23-24",
  //   source: "23",
  //   target: "24",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e24-25",
  //   source: "24",
  //   target: "25",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e24-26",
  //   source: "24",
  //   target: "26",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e1-27",
  //   source: "1",
  //   target: "27",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e27-28",
  //   source: "27",
  //   target: "28",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e28-28",
  //   source: "28",
  //   target: "29",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e1-30",
  //   source: "1",
  //   target: "30",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e30-31",
  //   source: "30",
  //   target: "31",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e31-32",
  //   source: "31",
  //   target: "32",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e31-33",
  //   source: "31",
  //   target: "33",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e31-34",
  //   source: "31",
  //   target: "34",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e31-35",
  //   source: "31",
  //   target: "35",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e30-36",
  //   source: "30",
  //   target: "36",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e36-37",
  //   source: "36",
  //   target: "37",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e36-38",
  //   source: "36",
  //   target: "38",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e36-39",
  //   source: "36",
  //   target: "39",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e36-40",
  //   source: "36",
  //   target: "40",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e1-41",
  //   source: "1",
  //   target: "41",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e41-42",
  //   source: "41",
  //   target: "42",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e42-43",
  //   source: "42",
  //   target: "43",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  // {
  //   id: "e42-44",
  //   source: "42",
  //   target: "44",
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //   },
  // },

  //END
];
